import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import * as React from "react";
import { hideAppSpinner, showAppSpinner } from "../../context/Store/slices/appSpinnerSlice";
import { showErrorToast, showSuccessToast } from "../../utils";
import { useDispatch } from "react-redux";
import { esgAdminKeys, useUpdateOrgModules } from "../../hooks/query/esg-admin/esg-admin";
import { useQueryClient } from "react-query";
import MODULES from "config/modules";

/**
 * These are used in paths.js
 * Which works via WithAuthorization -> isModuleAvailable() -> GLOBAL.organizationModules
 * AuthProvider sets this when you login.
 */
const MODULES_LIST = Object.keys(MODULES);

const ModuleListPopup = ({ organization, isOpen, onClose }) => {
  const [selectedModules, setSelectedModules] = React.useState([]);
  const toast = useToast();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (organization?.modules) {
      setSelectedModules(organization.modules);
    } else {
      setSelectedModules([]);
    }
  }, [organization]);

  const { mutate: updateOrgModules } = useUpdateOrgModules({
    onMutate: () => dispatch(showAppSpinner()),
    onSuccess: () => {
      showSuccessToast(toast, "Module list updated successfully");
      queryClient.invalidateQueries(esgAdminKeys.orgs());
      onClose();
    },
    onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    onSettled: () => dispatch(hideAppSpinner()),
  });

  const handleSave = () => {
    const data = {
      modules: selectedModules,
      tenantId: organization.tenantId,
    };
    updateOrgModules(data);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent bg="pureWhite">
        <ModalHeader>Manage Modules</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {/* Checkbox with list of modules, with checked if module is in organization.modules */}
          <CheckboxGroup colorScheme="limeShade">
            {MODULES_LIST.map((module) => (
              <Flex gap={4} key={module}>
                <Checkbox
                  isChecked={selectedModules?.includes(module)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedModules([...selectedModules, module]);
                    } else {
                      setSelectedModules(selectedModules.filter((m) => m !== module));
                    }
                  }}
                  width="max-content"
                  maxWidth="100%"
                >
                  {module}
                </Checkbox>
              </Flex>
            ))}
          </CheckboxGroup>
        </ModalBody>

        <ModalFooter>
          <Flex gap={2}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => handleSave()}>
              Save
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModuleListPopup;
